import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
       path: '/login',
       component: () => import('./views/Login.vue')
    },
    {
      path: '/login/:codigo',
      props: true,
      component: () => import('./views/Login.vue')
   },
   {
      path: '/aplicativo',
      component: () => import('./views/Aplicativo.vue')
    },
    {
      path: '/sala-espera',
      component: () => import('./views/SalaEspera.vue')
    },
    {
      path: '*',
      redirect: '/login'
    }
  ]
})

// router.beforeResolve((to, from, next) =>{
//   //validar token
//   if (to.path == '/login') {
//     next()
//   }else{
   
//   }
// })

export default router
